import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=48459a63&scoped=true"
import script from "./RememberPassword.vue?vue&type=script&lang=js"
export * from "./RememberPassword.vue?vue&type=script&lang=js"
import style0 from "./RememberPassword.vue?vue&type=style&index=0&id=48459a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48459a63",
  null
  
)

export default component.exports